<!--
  功能：功能描述
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="qsopen">
        <div class="content">
            <div class="nav">
                <div class="nav_but"  id="操作指南"   @click="gotoZnFunc()"  >
                     操作指南
                </div>
                <!-- 按钮 -->
                <div class="nav_but" v-if="stepInfo == 1" @click="showPopup = true" id="登录实盘"  >
                    <van-icon name="user-o" color="#e4e9fe" /> 登录实盘
                </div>
                <div class="nav_but" v-if="stepInfo == 2" @click="showPopup = true" id="登录实盘"  >
                    <van-icon name="user-o" color="#e4e9fe" /> 登录实盘
                </div>
                <div class="nav_but" v-if="stepInfo == 3" @click="showSingDialogFunc()" id="立即签约2" >
                    <van-icon name="edit" color="#e4e9fe"  /> {{signStatus == 0 ? '立即签约' : '我的签约'}}
                </div>
                <div class="nav_but" v-if="stepInfo == 4" @click="showSingDialogFunc()" id="立即签约2" >
                    <van-icon name="edit" color="#e4e9fe"  /> 我的签约
                </div>
            </div>
            <div class="nav-top" v-if="yztsShow" >
                <span class="nav-top-text" >权限已到期,签约完成即送一年因子投研权限</span>
            </div>
            <img src="@/assets/image/qs/01.jpg" alt="" />
            <img src="@/assets/image/qs/02.jpg" alt="" />
            <img src="@/assets/image/qs/03.jpg" alt="" />
            <img src="@/assets/image/qs/04.jpg" alt="" />
            <img src="@/assets/image/qs/05.jpg" alt="" />
            <img src="@/assets/image/qs/06.jpg" alt="" />
            <img src="@/assets/image/qs/07.jpg" alt="" />
            <img src="@/assets/image/qs/08.jpg" alt="" />
            <img src="@/assets/image/qs/09.jpg" alt="" />

            <p class="risk">
                【风险提示】量化投资存在策略失效风险及市场波动风险。策略模型可能因数据偏差、参数失效、市场环境变化等因素导致收益不及预期；历史回测业绩不代表未来表现。投资者应根据自身风险承受能力独立审慎决策，自行承担投资可能产生的全部损失。
                股市有风险，入市需谨慎。本广告不构成任何投资建议
            </p>

            <!-- 第一步 没有权限 -->
            <div class="footer" v-if="stepInfo == 1" >
                <!-- 立即体验 -->
                <div>
                    <div class="f-info f-info2">
                        <div class="f-info-left">
                            <p class="name">点击即送一个月</p>
                            <p class="name">量化投研权限</p>
                            <p class="hint">每个用户限领一次</p>
                        </div>

                        <p>
                            <!-- 赠送按钮 -->
                            <img src="@/assets/image/qs/qianyue.png" alt="" class="btn1-icon" @click="giftUserPowerFunc()" />
                        </p>
                    </div>
                </div>
            </div>

            <!-- 步骤2 : 没有权限 -->
           <div class="footer2" v-if="stepInfo == 2 && !isOpenQs" >
                <!-- 券商签约按钮 -->
                <div class="singBtn" @click="showSingDialogFunc" id="立即签约" >立即签约</div>
            </div>

            <div class="footer" v-if="stepInfo == 2 && isOpenQs" >
                <!-- 立即签约 -->
                <div class="f-info f-info3">
                    <div class="f3-info-left" >
                        <div class="left-img" >
                            <img src="@/assets/image/qs/xc.png" alt="" srcset="" v-if="isUserOpen.type == 'xc'" >
                            <img src="@/assets/image/qs/fz.png" alt="" srcset="" v-if="isUserOpen.type == 'fz'" >
                        </div>
                        <div class="left-title">
                            <div class="left-title-flex" >
                                <p class="name">{{ isUserOpen.crmName }}</p>
                                <div class="icon" >
                                    <img src="@/assets/image/qs/exchange.png" alt="" srcset="" @click="showSingDialogFunc" >
                                </div>
                            </div>

                            <p class="hint">量化投资签约</p>
                        </div>
                    </div>


                    <div class="singBtn"  id="立即签约" @click="showSingQsFunc(isUserOpen.url, isUserOpen.type)"  >立即签约</div>

                    <!-- <p>
                        <img src="@/assets/image/qs/11.png" alt="" class="btn1-icon" id="立即签约"  @click="showSingQsFunc(isUserOpen.url, isUserOpen.type)"  />
                    </p> -->
                </div>

                <!-- <p class="expect" @click="showSingDialogFunc" >更多券商</p> -->
            </div>

            <!-- 第三步 : 已绑定 -->
            <div class="footer" v-if="stepInfo == 3" >
                <!-- 进入 -->
                <div >
                    <div class="f-info">
                        <div class="f-info-left">
                            <div class="head">
                                <img src="@/assets/image/qs/hx.png" alt="" class="head-portrait"
                                    v-if="userInfo.spInfo.qs_type == 1" />
                                <img src="@/assets/image/qs/fz.png" alt="" class="head-portrait"
                                    v-if="userInfo.spInfo.qs_type == 2" />
                                <img src="@/assets/image/qs/xc.png" alt="" class="head-portrait"
                                    v-if="userInfo.spInfo.qs_type == 3" />
                                <div>
                                    <p class="name">
                                        {{
                                            userInfo.spInfo.qs_type == 1
                                                ? '华鑫证券'
                                                : userInfo.spInfo.qs_type == 2
                                        ? '方正证券'
                                        : '湘财证券'
                                        }}
                                    </p>
                                    <p class="num" @click="showPopup = true">
                                        <span>{{ maskString(userInfo.spInfo.capital_id) }}</span>
                                        <van-icon name="setting-o" class="num-icon"></van-icon>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <p class="enterBtn" @click="gotoQsInfo()" >进入</p>
                    </div>
                </div>
            </div>



            <!-- 第四步 : 未绑定已签约  -->
            <div class="footer2" v-if="stepInfo == 4" >
                <!-- 券商签约按钮 -->
                 <div>
                    <div class="singBtn" @click="showPopup = true" >登录实盘</div>
                 </div>
            </div>


        </div>

        <!-- 弹框 -->
        <van-popup v-model="showPopup" closeable round position="bottom" :style="{ height: '70%' }" class="spEdit">
            <div class="popup-content">
                <h1>登录实盘</h1>
                <div class="label">
                    <p>第一步</p>
                    <p>绑定资金账号</p>
                </div>

                <div class="content-box">
                    <ul class="securities-list">
                        <li v-for="(item, index) in shipan_qslist" :key="index" class="securities-list-item"
                            :class="{ selected: selectedIndex === index }" @click="selectItem(index)">
                            <img src="@/assets/image/qs/hx.png" alt="" v-show="item.value==1" />
                            <img src="@/assets/image/qs/fz.png" alt="" v-show="item.value==2" />
                            <img src="@/assets/image/qs/xc.png" alt="" v-show="item.value==3" />
                            <span class="securities-list-text" >{{ item.label }}</span>
                        </li>
                    </ul>

                    <p class="hint">
                        资金账号：
                        <i>（一个大智慧账号只能绑定一个资金账号）</i>
                    </p>

                    <div class="input-box">
                        <van-field v-model="number" placeholder="请输入资金账号"></van-field>
                        <button class="btn" @click="bindingQs()">确认</button>
                    </div>
                </div>

                <button class="goSP" @click="gotoQsInfo()" >去实盘页</button>
            </div>
        </van-popup>

        <!-- 选择策略 -->
        <van-popup v-model="showPicker" round position="bottom" class="selCl">
            <van-picker title="选择策略" show-toolbar :columns="columnsMn" @confirm="onConfirm" @cancel="onCancel"
                @change="onChange"></van-picker>
        </van-popup>

        <!-- 签约的弹窗 -->
        <van-popup v-model="signDialogShow" class="singn-dialog-box"  >
            <div class="singn-dialog-info" >
                <div class="singn-dialog-title" >
                    <div></div>
                    <div>签约证券</div>
                    <div>
                        <van-icon name="cross" color="#9ca3af" font-size="20px" @click="signDialogShow = false" > </van-icon>
                    </div>
                </div>
                <div class="singn-dialog-list" >
                    <div class="singn-dialog-item" :class="{'selected': selectedQsIndex === 0}" @click="selectedQsIndex = 0" >
                        <div class="singn-dialog-item-qs" >
                            <div class="singn-dialog-item-qs-icon" >
                                <img src="@/assets/image/qs/xc.png" alt="" srcset="">
                            </div>
                            <div class="singn-dialog-item-qs-name" >湘财证券</div>
                        </div>
                        <div class="singn-dialog-item-qs-select" >
                            <img src="@/assets/image/qs/select.png" alt="" srcset="" class="" v-if="selectedQsIndex === 0" > </img>
                            <img src="@/assets/image/qs/ont-select.png" alt="" srcset="" class="" v-else > </img>
                        </div>
                    </div>
                    <div class="singn-dialog-item" :class="{'selected': selectedQsIndex === 1}" @click="selectedQsIndex = 1" >
                        <div class="singn-dialog-item-qs" >
                            <div class="singn-dialog-item-qs-icon" >
                                <img src="@/assets/image/qs/fz.png" alt="" srcset="">
                            </div>
                            <div class="singn-dialog-item-qs-name" >方正证券</div>
                        </div>
                        <div class="singn-dialog-item-qs-select" >
                            <img src="@/assets/image/qs/select.png" alt="" srcset="" class="" v-if="selectedQsIndex === 1" > </img>
                            <img src="@/assets/image/qs/ont-select.png" alt="" srcset="" class="" v-else > </img>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="singn-dialog-btn" @click="signGoToQs()" >立即签约</div>
                </div>
            </div>

        </van-popup>

    </div>
</template>

<script>
import { getUserCheck, setUserPower, getMyRealityMn, insertQsInfo,getJsonData,actionSign,getSignStatus,getOpenStatus } from '@/api/index.js';
import { compareVersions } from '@/utils/format';
import CryptoJS from 'crypto-js';
export default {
    name: 'qsopen',
    data() {
        return {
            showPopup: false,
            list: [3,2],
            selectedIndex: 0,
            number: '',
            showPicker: false,
            value: '',
            // 权限集合
            userInfo: {},
            userPower: false,
            // 赠送dialog
            giftDialog: false,
            // 签约弹窗
            signDialog: false,
            // 实盘弹窗
            spDialog: false,
            // 登录按钮
            loginShow: false,
            // 签约按钮
            signShow: false,
            // 获取下载的模拟
            columnsMn: [],
            // 选中的模拟交易
            selectMn: {},
            selectMnName: '',
            selectMySpcl: '', // 加密数据
            // 接受运营参数
            channel: '',
            dzhadid: '',
            reportObj:{},
            // 实盘券商list
            shipan_qslist:[],
            // 签约状态
            signStatus: 0,
            // 签约类型
            signType: 'xc',
            // 步骤 : 1-
            stepInfo: null,
            // 弹窗展示
            signDialogShow: false,
            selectedQsIndex:0,
            // 是否开过户: 未签约状态下,如果开户就展示开户信息,否则就随机
            isOpenQs: false,
            isUserOpen:{},
            yztsShow:false,
        };
    },
    filters: {},
    // 侦听器
    watch: {},
    /**
     * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
     */
    created() {
        //
        this.shipan_qslist = window.SHIPAN_QSLIST;



        // 获取用户权限以及登录信息以及签约状态
        this.componentUserFunc();

        // 获取用户的模拟交易
        this.getMyRealityMnFunc();
    },
    /**
     * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
     * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
     */
    mounted: function () {
        document.querySelector('html').style.background = '#0a1139';
        this.channel = this.$route.query.channel?this.$route.query.channel:window.config.WEB_CHANNEL;
        this.dzhadid = this.$route.query.dzhadid?this.$route.query.dzhadid:window.config.WEB_DZHADID;

        var _this = this;
        setTimeout(function(){
            _this.pageVisit();
        },200);

    },
    // 组件方法
    methods: {
        compareVersions,
        selectItem: function (index) {
            this.selectedIndex = index;
        },

        onConfirm: function (value, index) {
            this.selectMn = value;
            this.selectMnName = value.name;
            this.showPicker = false;
            // this.$toast('当前值：' + value + ', 当前索引：' + index);
        },

        onChange: function (picker, value, index) {
            // this.$toast('当前值：' + value + ', 当前索引：' + index);
        },

        onCancel: function () {
            this.showPicker = false;
        },

        // 获取用户综合状态
        componentUserFunc:function (){
            var _this = this;
            //  同步同时获取两个接口
            Promise.allSettled([
                // 获取用户的签约状态
                this.getSignStatusFunc(),
                // 获取用户权限以及登录信息
                this.getUserInfoFun(),
                // 获取用户开户状态
                this.getOpenQsStatusFunc(),
            ]).then((results) => {
                // 两个接口都返回了结果
                console.log('results',results)
                // results[0] 签约状态  results[1] 用户信息
                if(results[0].status == 'fulfilled' && results[1].status == 'fulfilled'){
                    // 处理结果
                    if(results[1].value.err == 200) {
                        // 校验成功 (有权限)
                        _this.userInfo = results[1].value.data;
                        _this.userPower = true;
                        // 是否绑定过账号
                        if (_this.userInfo.sp) {
                            _this.number = _this.userInfo.spInfo.capital_id;
                            // 绑定的哪家券商
                            _this.selectedIndex = _this.checkQsTypeInIndexFuc(_this.userInfo.spInfo.qs_type);
                            // 有权限绑定过 步骤3
                            _this.stepInfo = 3;
                            // 查看是否签约过
                            if(results[0].value.err == 200) {
                                // 是否签约过方正
                                if(Object.keys(results[0].value.data.xc).length > 0) {
                                    // 已签约,显示我的签约
                                    _this.signStatus = 1;
                                    // 签约状态
                                    _this.selectedQsIndex = 0;
                                } else if (Object.keys(results[0].value.data.fz).length > 0) {
                                   // 已签约,显示我的签约
                                    _this.signStatus = 1;
                                    // 签约状态
                                    _this.selectedQsIndex = 1;
                                } else {
                                    // 未签约,显示立即签约
                                    _this.signStatus = 0;
                                }
                            } else {
                                // 未签约,显示立即签约
                                _this.signStatus = 0;
                            }
                        } else {
                            // 有权限,未绑定
                            // 查看是否签约过
                            if(results[0].value.err == 200) {
                                // 是否签约过方正
                                if(Object.keys(results[0].value.data.xc).length > 0) {
                                    // 签约状态
                                    _this.selectedQsIndex = 0;
                                    _this.stepInfo = 4;
                                    _this.selectedIndex = _this.checkQsTypeInIndexFuc(3);
                                } else if (Object.keys(results[0].value.data.fz).length > 0) {
                                    // 签约状态
                                    _this.selectedQsIndex = 1;
                                    _this.stepInfo = 4;
                                    _this.selectedIndex = _this.checkQsTypeInIndexFuc(2);
                                } else {
                                    // 没绑定过也没签约过
                                    _this.selectedQsIndex = 0;
                                    _this.stepInfo = 2;
                                    // 查询开户状态
                                    console.log('results[2].value.data',results[2].value)
                                    if(results[2].value.err == 200) {
                                        _this.isUserOpen = _this.getQsInfoSelect(results[2].value.data);
                                        console.log('_this.isUserOpen',_this.isUserOpen);

                                        if(_this.isUserOpen == null) {
                                            _this.isOpenQs = false;
                                        } else {
                                            _this.isOpenQs = true;
                                        }
                                    } else {
                                        _this.isOpenQs = false;
                                        _this.isUserOpen = null;
                                    }
                                }
                            } else {
                                 _this.stepInfo = 2;
                                 if(results[2].value.err == 200) {
                                    _this.isUserOpen = _this.getQsInfoSelect(results[2].value.data);
                                    if(_this.isUserOpen == null) {
                                        _this.isOpenQs = false;
                                    } else {
                                        _this.isOpenQs = true;
                                    }
                                } else {
                                    _this.isOpenQs = false;
                                    _this.isUserOpen = null;
                                }
                            }
                        }
                    } else {
                        // 无权限
                        _this.userInfo = results[1].value.data;
                        _this.userPower = false;
                        // 判断是否开过217 , 未开过打开赠送弹窗
                        if (_this.userInfo.code == 'E10002') {

                            console.log('results[2].value.data',results[2].value)
                            // 步1
                            _this.stepInfo = 1;
                            if (_this.userInfo.sp) {
                                _this.number = _this.userInfo.spInfo.capital_id;
                                // 绑定的哪家券商
                                _this.selectedIndex = _this.checkQsTypeInIndexFuc(_this.userInfo.spInfo.qs_type);
                                // 显示步骤3
                               _this.stepInfo = 3;
                               // 查看是否签约过
                                if(results[0].value.err == 200) {
                                    // 是否签约过方正
                                    if(Object.keys(results[0].value.data.xc).length > 0) {
                                        // 已签约,显示我的签约
                                        _this.signStatus = 1;
                                        // 签约状态
                                        _this.selectedQsIndex = 0;
                                    } else if (Object.keys(results[0].value.data.fz).length > 0) {
                                    // 已签约,显示我的签约
                                        _this.signStatus = 1;
                                        // 签约状态
                                        _this.selectedQsIndex = 1;
                                    } else {
                                        // 未签约,显示立即签约
                                        _this.signStatus = 0;
                                    }
                                } else {
                                    // 未签约,显示立即签约
                                    _this.signStatus = 0;
                                }
                            } else {
                                // 无权限,未绑定
                                // 查看是否签约过
                                if(results[0].value.err == 200) {
                                    // 是否签约过方正
                                    if(Object.keys(results[0].value.data.xc).length > 0) {
                                        // 签约状态
                                        _this.selectedQsIndex = 0;
                                        _this.stepInfo = 4;
                                        _this.selectedIndex = _this.checkQsTypeInIndexFuc(3);
                                    } else if (Object.keys(results[0].value.data.fz).length > 0) {
                                        // 签约状态
                                        _this.selectedQsIndex = 1;
                                        _this.stepInfo = 4;
                                        _this.selectedIndex = _this.checkQsTypeInIndexFuc(2);
                                    } else  {
                                        // 没绑定过也没签约过
                                        _this.selectedQsIndex = 0;
                                        _this.stepInfo = 1;
                                        // 查询开户状态
                                        console.log('results[2].value.data',results[2].value)
                                        if(results[2].value.err == 200) {
                                            _this.isUserOpen = _this.getQsInfoSelect(results[2].value.data);
                                            console.log('_this.isUserOpen',_this.isUserOpen);

                                            if(_this.isUserOpen == null) {
                                                _this.isOpenQs = false;
                                            } else {
                                                _this.isOpenQs = true;
                                            }
                                        } else {
                                            _this.isOpenQs = false;
                                            _this.isUserOpen = null;
                                        }

                                    }
                                } else {
                                    _this.stepInfo = 1;
                                    if(results[2].value.err == 200) {
                                        _this.isUserOpen = _this.getQsInfoSelect(results[2].value.data);
                                        if(_this.isUserOpen == null) {
                                            _this.isOpenQs = false;
                                        } else {
                                            _this.isOpenQs = true;
                                        }
                                    } else {
                                        _this.isOpenQs = false;
                                        _this.isUserOpen = null;
                                    }
                                }
                            }
                        } else if (_this.userInfo.code == 'E10003') {
                            // 无权限(已开通)
                            // 步1
                            _this.stepInfo = 2;
                            _this.yztsShow = true;
                            if (_this.userInfo.sp) {
                                // 显示步骤3
                                _this.stepInfo = 3;
                                _this.number = _this.userInfo.spInfo.capital_id;
                                // 绑定的哪家券商
                                _this.selectedIndex = _this.checkQsTypeInIndexFuc(_this.userInfo.spInfo.qs_type);
                                // 查看是否签约过
                                if(results[0].value.err == 200) {
                                    // 是否签约过方正
                                    if(Object.keys(results[0].value.data.xc).length > 0) {
                                        // 已签约,显示我的签约
                                        _this.signStatus = 1;
                                        // 签约状态
                                        _this.selectedQsIndex = 0;
                                    } else if (Object.keys(results[0].value.data.fz).length > 0) {
                                    // 已签约,显示我的签约
                                        _this.signStatus = 1;
                                        // 签约状态
                                        _this.selectedQsIndex = 1;
                                    } else {
                                        // 未签约,显示立即签约
                                        _this.signStatus = 0;
                                    }
                                } else {
                                    // 未签约,显示立即签约
                                    _this.signStatus = 0;
                                }
                            } else {
                                // 无权限(已开通),未绑定
                                // 查看是否签约过
                                if(results[0].value.err == 200) {
                                    // 是否签约过方正
                                    if(Object.keys(results[0].value.data.xc).length > 0) {
                                        // 签约状态
                                        _this.selectedQsIndex = 0;
                                        _this.stepInfo = 4;
                                        _this.selectedIndex = _this.checkQsTypeInIndexFuc(3);
                                    } else if (Object.keys(results[0].value.data.fz).length > 0) {
                                        // 签约状态
                                        _this.selectedQsIndex = 1;
                                        _this.stepInfo = 4;
                                        _this.selectedIndex = _this.checkQsTypeInIndexFuc(2);
                                    } else {
                                        // 没绑定过也没签约过
                                        _this.selectedQsIndex = 0;
                                        _this.stepInfo = 2;
                                        // 查询开户状态
                                        if(results[2].value.err == 200) {
                                            _this.isUserOpen = _this.getQsInfoSelect(results[2].value.data);

                                            if(_this.isUserOpen == null) {
                                                _this.isOpenQs = false;
                                            } else {
                                                _this.isOpenQs = true;
                                            }
                                        } else {
                                            _this.isOpenQs = false;
                                            _this.isUserOpen = null;
                                        }
                                    }
                                } else {
                                    _this.stepInfo = 2;
                                    if(results[2].value.err == 200) {
                                        _this.isUserOpen = _this.getQsInfoSelect(results[2].value.data);
                                        if(_this.isUserOpen == null) {
                                            _this.isOpenQs = false;
                                        } else {
                                            _this.isOpenQs = true;
                                        }
                                    } else {
                                        _this.isOpenQs = false;
                                        _this.isUserOpen = null;
                                    }
                                }
                            }
                        } else {
                           // 步数
                            _this.stepInfo = null;
                        }
                    }
                } else {
                    // 步数
                    _this.stepInfo = null;
                }
            }).catch((error) => {
                // 步数
                _this.stepInfo = null;
            });
        },

        getQsInfoSelect:function(data){
            const { xc, fz, qsList } = data;
            // 1 xc 有值 返回 qsList 中 type = xc 的数组
            if (Array.isArray(xc) && xc.length > 0) {
                return qsList.filter(qs => qs.type === 'xc');
            }
            // 2 fz 有值 返回 qsList 中 type = fz 的数组
            if (Array.isArray(fz) && fz.length > 0) {
                return qsList.filter(qs => qs.type === 'fz');
            }
            // 3 都没值，从 qsList 选一个: 根据 ratio 权重随机取一个
            if (Array.isArray(qsList) && qsList.length > 0) {
                // 计算权重总和
                const totalRatio = qsList.reduce((acc, cur) => acc + cur.ratio, 0);
                // 生成随机数
                const random = Math.random() * totalRatio;
                // 根据权重随机取一个
                let currentRatio = 0;
                for (const qs of qsList) {
                    currentRatio += qs.ratio;
                    if (random <= currentRatio) {
                        return qs;
                    }
                }
            }
            // 兜底
            return null;
        },

        // 查询签约状态
        getSignStatusFunc:function(){
            var _this = this;
            return new Promise((resolve, reject)=>{
                getSignStatus({}).then((result) => {
                    if(result.err == 200) {
                         resolve(result);

                    } else {
                        reject({});
                    }
                }).catch((err) => {
                    reject({});
                });
            })
        },

        // 查询开户状态
        getOpenQsStatusFunc:function(){
            var _this = this;
            return new Promise((resolve, reject)=>{
                getOpenStatus({}).then((result) => {
                    if(result.err == 200) {
                         resolve(result);

                    } else {
                        reject({});
                    }
                }).catch((err) => {
                    reject({});
                });
            })
        },

        // 获取用户信息以及权限
        getUserInfoFun: function () {
            var _this = this;
            return new Promise((resolve, reject)=>{
                getUserCheck({}).then((result) => {
                    resolve(result);
                }).catch((err) => {
                    reject({});
                });
            })
        },
        // 点击赠送权限按钮
        giftUserPowerFunc: function () {
            var _this = this;
            var params = {};
            setUserPower(params)
                .then((result) => {
                    if (result.err == 200) {
                        // 开户成功
                        _this.stepInfo = 2;
                        // if(_this.isOpenQs) {
                        //     _this.showSingQsFunc(_this.isUserOpen.url, _this.isUserOpen.type)
                        // }
                    } else {
                        // 开户失败
                        _this.stepInfo = 2;
                        // if(_this.isOpenQs) {
                        //     _this.showSingQsFunc(_this.isUserOpen.url, _this.isUserOpen.type)
                        // }
                    }
                })
                .catch((err) => {
                    // 开户失败
                    _this.stepInfo = 2;
                });
        },

        // 获取用户可以导出的模拟交易
        getMyRealityMnFunc: function () {
            var _this = this;
            var params = {};
            getMyRealityMn(params)
                .then((result) => {
                    if (result.data.length > 0) {
                        result.data.forEach((element) => {
                            element.text = element.name;
                        });
                        _this.columnsMn = result.data;
                    }
                })
                .catch((err) => { });
        },

        // 点击显示模拟交易列表
        showPickerInfo: function () {
            var _this = this;
            if (_this.columnsMn.length > 0) {
                _this.showPicker = true;
            } else {
                // 暂无数据
                this.$toast('暂无数据');
            }
        },

        // 点击导出策略
        downloadCl: function () {
            var _this = this;
            // 判断版本号
            if (compareVersions(this.$route.query.version, '10.0.0')) {
                // 判断对象是否为空
                if (Object.keys(_this.selectMn).length > 0) {
                    // 获取用户可以导出的模拟交易
                    // console.log('_this.selectMn',_this.selectMn);
                    this.selectMyClDown();
                } else {
                    // 暂无数据
                    this.$toast('请先创建模拟交易');
                }
            } else {
                // 暂无数据
                this.$toast('请先升级大智慧客户端到最新版本');
            }
        },

        // 处理加密内容
        selectMyClDown: function () {
            var _this = this;
            if (this.userInfo.sp) {
                _this.selectMn.investorId = this.userInfo.spInfo.capital_id;
                var spclSelectAES = _this.encryptData(JSON.stringify(_this.selectMn));
                _this.selectMySpcl = spclSelectAES;
                // 执行下载
                var file_content = _this.selectMySpcl;
                var file_name = _this.selectMnName + '.dzhqf';
                var params = {
                    fileName: file_name,
                    data: file_content
                };
                DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                    'saveFileToLocal',
                    JSON.stringify(params),
                    'downCallback'
                );
                function downCallback(data) {
                    alert(data);
                }
            } else {
                // 暂无数据
                this.$toast('请先绑定资金账号');
            }
        },

        // 加密数据
        encryptData: function (data) {
            var keyInfo = 'jEsp@4H!d2$K9f)#';
            var keyWordArray = CryptoJS.enc.Utf8.parse(keyInfo);
            // 加密数据
            var encryptedData = CryptoJS.AES.encrypt(data, keyWordArray, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7 // 使用PKCS7填充
            }).toString();
            return encryptedData;
        },

        // 绑定券商
        bindingQs: function () {
            var _this = this;
            if (this.number == '') {
                this.$toast('请正确填写资金账号');
            } else {
                var params = {
                    capital_id: _this.number,
                    qs_type: _this.shipan_qslist[_this.selectedIndex].value
                };
                insertQsInfo(params)
                    .then((result) => {
                        if(result.err == 200) {
                            _this.userInfo.sp = true;
                            _this.userInfo.spInfo = params;
                            this.$toast('绑定成功');
                        } else {
                            this.$toast('绑定失败');
                        }
                    })
                    .catch((err) => {
                        this.$toast('绑定失败');
                     });
            }
        },


        // 点击签约按钮
        gotoSingFunc: function () {
            var _this = this;
            // 判断对象是否为空
            var params = {
                source: _this.channel,
                mediaid: _this.dzhadid
            };
            var url = window.config.WEB_QSOPEN_URL+'&channel='+_this.channel+'&dzhadid='+_this.dzhadid;
            actionSign(params).then((result) => {
                window.location.href = url;
            }).catch((err) => {
                window.location.href = url;
            });

        },
        // 字符串中间打星号
        maskString(str) {
            if (str.length <= 7) return str;

            const frontLen = 3;
            const backLen = 3;
            const masked = '****';

            return str.slice(0, frontLen) + masked + str.slice(-backLen);
        },
        // 点击跳转到券商
        gotoQsInfo:function(){
            let jsonStr = {
                number: this.number,
                password: '',
            };
            let jsonStr2 = JSON.stringify(jsonStr);
            if(this.userInfo.sp) {
                if(this.userInfo.spInfo.qs_type == 3) {
                    // 跳转湘财
                    window.location.href = window.config.WEB_QSOPEN_URL_XC+"&info=" + btoa(encodeURIComponent(jsonStr2));
                } else if(this.userInfo.spInfo.qs_type == 2) {
                    // 跳转到方正
                    window.location.href = window.config.WEB_QSOPEN_URL_FZ+"&info=" + btoa(encodeURIComponent(jsonStr2));
                } else {
                    this.$toast('敬请期待');
                }
            } else {
                this.$toast('请正确填写资金账号.');
            }
        },
        // 点击签约弹窗
        showSingDialogFunc : function () {
            var _this = this;
            _this.signDialogShow = true;

        },
        // 未开户点击签约分配券商
        showSingQsFunc:function(url,type){
            var _this = this;
            if(type == 'xc') {
                var trackObj = {
                    button_id: '378',
                };
                sensors.track('web_button_click', trackObj);
            } else if(type == 'fz') {
                var trackObj = {
                    button_id: '374',
                };
                sensors.track('web_button_click', trackObj);
            }
            window.location.href = url+'&channel='+_this.channel+'&dzhadid='+_this.dzhadid;;
        },
        // 点击立即签约跳转
        signGoToQs:function(){
            var _this = this;

            // 判断对象是否为空
            var params = {
                source: _this.channel,
                mediaid: _this.dzhadid
            };
            // var url = window.config.WEB_QSOPEN_URL+'&channel='+_this.channel+'&dzhadid='+_this.dzhadid;
            // actionSign(params).then((result) => {
            //     window.location.href = url;
            // }).catch((err) => {
            //     window.location.href = url;
            // });

            if(_this.selectedQsIndex == 0) {
                this.$toast('暂不支持');
                return;
                // 跳转到湘财
                // var url = window.config.WEB_QSOPEN_URL+'&channel='+_this.channel+'&dzhadid='+_this.dzhadid;
                // params.trade = '16300';
            } else {
                var url = window.realMeQslist[1].open+'&channel='+_this.channel+'&dzhadid='+_this.dzhadid;
                params.trade = '12100';
            }
            actionSign(params).then((result) => {
                window.location.href = url;
            }).catch((err) => {
                window.location.href = url;
            });
        },
        // 校验用户绑定的哪家券商 并返回 index
        checkQsTypeInIndexFuc:function(qsType){
            var _this = this;
            var resultIndex = 0;
            _this.shipan_qslist.forEach((item, index) => {
                if(item.value == qsType) {
                    resultIndex = index;
                }
            });
            return resultIndex;
        },
        // 点击跳转量化操作指南
        gotoZnFunc: function() {
            window.location.href = window.WEB_QSOPEN_URL_ZN;
        },
        pageVisit: function() {
            var trackObj = {
                page_id: '115',
            };
            sensors.track('web_page_visit', trackObj);
        },



    }
};
</script>

<style scoped lang="less">

// html, body, #app {
//   max-width: 375px;
//   margin: 0 auto;
// }

.content {
    padding-bottom: 150px;
}

.nav {
    background: rgba(24, 38, 72, 0.2);
    backdrop-filter: blur(14px);
    position: fixed;
    top: 0;
    width: 100%;
    height: 71px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    // max-width: 375px;

    .nav_but {
        padding: 8px 12px;
        background: rgba(255, 255, 255, 0.06);
        border-radius: 15px;
        color: #e4e9fe;
        font-size: 13px;
        margin-right: 16px;
    }
}

.nav .nav-right {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #fff;
    line-height: 14px;
}

.nav .nav-right button {
    width: 106px;
    height: 35px;
    font-size: 16px;
    font-weight: 500;
    color: #4173ff;
    border: 1px solid #4173ff;
    border-radius: 30px;
    background: #000000;
    margin-left: 10px;
}

.nav-top {
    position: fixed;
    top: 80px;
    width: 100%;
    text-align: center;
    .nav-top-text {
        background-color: #ffdb8e;
        color: #732d10;
        font-size: 12px;
        padding: 2px 4px;
        border-radius: 4px;
    }
}


.footer {
    position: fixed;
    width: 90%;
    left: 50%;
    bottom: 0;
    max-width: 750px;
    transform: translateX(-50%);
    background: url('../../assets/image/qs/10.png') no-repeat center;
    background-size: 100% 100%;
    // border-radius: 20px 20px 0 0;
    max-width: 375px;
    border-radius:43px;
    margin-bottom: 20px;
}

.footer .f-info {
    // padding: 25px;
    padding: 10px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}


.footer .f-info3 .f3-info-left {
    display: flex;
}
.footer .f-info3 .f3-info-left .left-img {
    border-radius: 50%;
    overflow: hidden;
    width: 44px;
    height: 44px;
    margin-right: 10px;
}
.footer .f-info3 .f3-info-left .left-title-flex {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
}

.footer .f-info3 .f3-info-left .left-title-flex .icon {
    width: 14px;
    height: 14px;
    margin-left: 4px;
    margin-top: -2px;
    img {
        width: 100%;
        height: 100%;
        display: block;
    }
}

.footer .f-info3   .singBtn {
    width: 108px;
    height: 35px;
    background:linear-gradient(180deg,#ffdb8e 0%,#ffa532 100%);
    border-radius:30px;
    font-weight:500;
    color:#732d10;
    font-size:15px;
    text-align: center;
    line-height: 35px;
}

.footer .f-info3 .f3-info-left .left-title .name {
    font-size: 18px;
    font-weight: bold;
    //   margin-bottom: 5px;
    font-family: Alimama ShuHeiTi;
    color: #fff;
}

.footer .f-info3 .f3-info-left .left-title .hint {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.6);
    //   margin-top: 0.2rem;
}


.footer .f-info .f-info-left .name {
    font-size: 18px;
    font-weight: bold;
    //   margin-bottom: 5px;
    font-family: Alimama ShuHeiTi;
    color: #fff;
}

.footer .f-info .f-info-left .hint {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.6);
    //   margin-top: 0.2rem;
}

.footer .f-info .btn1-icon {
    width: 140px;
}

.risk {
    font-size: 0.24rem;
    line-height: 0.32rem;
    padding: 0 0.4rem;
    color: #fff;
}

.footer .expect {
    font-size: 10px;
    position: absolute;
    top: -20px;
    right: 0px;
    color: #fff;
}

.footer .f-info2 .f-info-left .name {
    background: linear-gradient(0deg, #ffffff -300%, #fff2b1 400%),
        linear-gradient(0deg, #ffffff -300%, #fff2b1 400%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}

.footer .f-info2 .btn1-icon {
    width: 125px;
}

.footer .f-info .enterBtn {
    width: 85px;
    height: 40px;
    background: linear-gradient(180deg, #ffdb8e 0%, #ffa532 100%);
    border-radius: 7.69px;
    flex-shrink: 0;
    font-weight: 500;
    color: #732d10;
    font-size: 0.38rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.footer .f-info .f-info-left .head {
    display: flex;
    align-items: center;
}

.footer .f-info .f-info-left .head .head-portrait {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
}

.footer .f-info .f-info-left .num {
    color: #ffffff;
    font-size: 13px;

    .num-icon {
        margin-left: 8px;
    }
}

.footer2 {
    position: fixed;
    width: 100%;
    left: 50%;
    bottom: 35px;
    max-width: 750px;
    transform: translateX(-50%);
    background-size: 100% 100%;
    border-radius: 20px 20px 0 0;
    max-width: 375px;
    padding: 0 26px;
    .singBtn {
        color:#ffffff;
        font-size:21px;
        font-weight:500;
        text-align: center;
         background: url('../../assets/image/qs/qsbut.png') no-repeat center;
        background-size: 100% 100%;
        height: 58px;
        line-height: 58px;
    }
}

#app .van-popup {
    background: #1b2035;
}

#app .spEdit {
    padding: 0.7rem 0.3rem 0.46rem;
}

/* #app .van-popup--bottom {
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
} */

.popup-content {
    /* border: 1px solid #f00; */
}

.popup-content h1 {
    font-weight: 500;
    color: #e4e9fe;
    font-size: 17px;
    text-align: center;
}

.popup-content .label {
    display: flex;
    align-items: center;
    margin-top: 28px;
}

.popup-content .label p {
    font-weight: 500;
    color: #e4e9fe;
    font-size: 15px;
}

.popup-content .label p:first-child {
    background: rgba(59, 133, 254, 0.3);
    border-radius: 4px;
    padding: 0.16rem 0.16rem;
    margin-right: 0.16rem;
}

.popup-content .content-box {
    background: rgba(255, 255, 255, 0.04);
    border-radius: 11.54px;
    padding: 0.23rem;
    margin-top: 12px;
}

.popup-content .content-box .securities-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    // align-items: center;
}
.popup-content .content-box .securities-list .securities-list-item {
    width: 48%;
    margin-bottom: 10px;
}

// .popup-content .content-box .securities-list li:first-child {
//     margin-right: 0.15rem;
// }

.popup-content .content-box .securities-list li {
    background: rgba(98, 100, 132, 0.16);
    border-radius: 11.54px;
    width: 50%;
    padding: 8px 15px;
    border: 1px solid rgba(98, 100, 132, 0);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;

    .securities-list-text {
        margin-left: 8px;
        color: #e4e9fe;
        font-size: 13px;
    }
}

.popup-content .content-box .securities-list li img {
    width: 27px;
    height: 27px;
    border-radius: 7px;
}

.popup-content .content-box .securities-list li.selected {
    border: 1px solid #3b85fe;
    background: #253e71;
}

.popup-content .content-box .hint {
    color: #e4e9fe;
    font-size: 14px;
    margin-top: 16px;
}

.popup-content .content-box .hint i {
    color: #909cb0;
    font-size: 12px;
}

.popup-content .content-box .input-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    color: #e4e9fe;
}

.popup-content .content-box .input-box .input-re {
    width: 100%;
    position: relative;
}

.popup-content .content-box .input-box .input-re .arrow-down {
    position: absolute;
    z-index: 9;
    right: 0.3rem;
    top: 50%;
    transform: translateY(-50%);
}

.popup-content .content-box .input-box .van-cell {
    background: #2e3248;
    border: 1px solid;
    border-color: #383c54;
    border-radius: 11.54px;
    padding: 6px 15px;
    font-size: 13px;
}

.popup-content {
    ::v-deep {
        .van-field__control {
            color: #e4e9fe;
            font-size: 13px;
        }
    }
}

.popup-content .van-cell::after {
    display: none;
}

.popup-content .btn {
    width: 77px;
    height: 31px;
    background: #3b85fe;
    border-radius: 7.69px;
    color: #ffffff;
    font-size: 13px;
    margin-left: 8px;
}

#app .van-picker {
    background: none;
}

::v-deep {
    .van-picker__mask {
        background-image: none;
    }
}

::v-deep {
    .van-picker-column__item {
        color: #e4e9fe;
    }
}

.van-popup {
    background: #1b2035;
}

.selCl {
    ::v-deep {
        .van-picker__title {
            color: #fff;
        }

        .van-picker__confirm {
            color: #3b85fe;
        }
    }
}

.selCl .van-picker__confirm {
    color: #3b85fe;
}

.popup-content .step {
    margin-top: 28px;
    color: #6b7687;
    font-size: 12px;
    text-align: center;
}

.popup-content .step a {
    color: #3b85fe;
}

.popup-content .goSP {
    margin-top: 40px;
    width: 100%;
    height: 40px;
    background: #3b85fe;
    border-radius: 7.69px;
    color: #ffffff;
    font-size: 15px;
}


// 签约弹窗
.singn-dialog-box {
     background: #fff !important;
      padding: 18px 23px;
      border-radius:8px;
}
.singn-dialog-info {
    width: 294px;
   .singn-dialog-title {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        color:#4e5969;
        font-size:16px;
        font-weight:500;
   }
   .singn-dialog-list {
        margin-top: 20px;
        margin-bottom: 20px;
        .singn-dialog-item {
            background:#f8f8fc;
            border: 1px solid #f8f8fc;
            border-radius:6px;
            padding: 19px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            .singn-dialog-item-qs {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: flex-start;
                align-items: center;
                .singn-dialog-item-qs-icon {
                    width: 35px;
                    height: 35px;
                    margin-right: 6px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .singn-dialog-item-qs-name {
                    color:#4e5969;
                    font-weight:500;
                    font-size:15px;
                }
            }
            .singn-dialog-item-qs-select {
                width: 24px;
                height: 24px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .selected {
            border: 1px solid #286df7;
        }
   }
   .singn-dialog-btn {
    background:#286df7;
    border-radius:8px;
    height: 41px;
    line-height: 41px;
    text-align: center;
    color:#ffffff;
    font-size:14px;
    font-weight:500;
   }
}
</style>
